const ProfileStart = {
  computed: {
    ...Vuex.mapState(['profile', 'schedules', 'availability']),
  },
  created() {
    this.$parent.$on('signup.loaded', () => {
      const type = urlQueryParams('type');
      if (['P', 'E'].includes(type)) {
        this.setType(type);
      }
    });
  },
  methods: {
    setType(type) {
      this.profile.type = type;
      this.$store.commit('set', { profile: this.profile });
      this.$router.push('/informacion');
    },
  },
  template: `
    <div>
      <p class="uk-text-center uk-h3">
        Para continuar, dinos quien eres:
      </p>
      <div
        uk-grid
        class="bloque-info uk-child-width-1-3@m uk-margin-top uk-grid-small"
        uk-height-match=".info-box"
      >
        <div>
          <div class="info-box">
            <div class="uk-text-center">
              <img src="/assets/img/drawn/autonomo.svg" alt="Empresa" />
            </div>
            <h2 class="uk-h3 uk-text-center uk-text-bold uk-text-uppercase dmtk-blue">
              Soy una autónomo o particular
            </h2>
            <p>
              ¿Buscas trabajo? ¿Eres profesional freelance? ¿Trabajas por tu cuenta? ¿Ofreces algún servicio a
              domicilio?
            </p>
          </div>
          <div class="uk-text-center">
            <button @click="setType('P')" class="uk-button uk-button-primary">
              Completa tu perfil
            </button>
          </div>
        </div>
        <div class="uk-flex-first@s">
          <div class="info-box">
            <div class="uk-text-center">
              <img src="/assets/img/drawn/empresa.svg" alt="Empresa" />
            </div>
            <h2 class="uk-h3 uk-text-center uk-text-bold uk-text-uppercase dmtk-blue">
              Represento a una empresa
            </h2>
            <p>
              Incluye tu empresa en Doméstiko y empieza ya a recibir contactos de clientes completamente gratis,
              añade toda la información que quieras a tu perfil de empresa.
            </p>
          </div>
          <div class="uk-text-center">
            <button @click="setType('E')" class="uk-button uk-button-primary">
              Completa tu perfil
            </button>
          </div>
        </div>
        <div>
          <div class="info-box">
            <div class="uk-text-center">
              <img src="/assets/img/drawn/busca.svg" alt="" />
            </div>
            <h2 class="uk-h3 uk-text-center uk-text-bold uk-text-uppercase dmtk-blue">
              Necesito un servicio
            </h2>
            <p>
              Pon un anuncio gratuito, o pide un presupuesto, para solicitar un servicio o la realización
              de un trabajo y se lo enviaremos a los profesionales de la zona.
            </p>
          </div>
          <div class="uk-text-center">
            <a class="uk-button uk-button-primary" href="/empleo/publicar/">
              Publica una oferta
            </a>
          </div>
        </div>
      </div>
    </div>
  `,
};
